import { api } from '../api/robyBackend';

// Die .docx-Datei selbst wird über den generischen Dokumenten-Upload (derselbe Upload-Button
// wie bei allen anderen Apps) hochgeladen; dieser Call startet nur die Verarbeitung des
// zuletzt hochgeladenen Dokuments dieser Session.
export const startLektoratJob = async (app, sessionId) => {
  await api.post(`/chat/${app}/${sessionId}/lektorat/start/`, null);
};

export const fetchLektoratStatus = async (app, sessionId) => {
  const response = await api.get(`/chat/${app}/${sessionId}/lektorat/status/`);
  return response.data; // { status, message, progress }
};

/**
 * Pollt /lektorat/status/ bis der Job 'done' oder 'error' meldet.
 * shouldStop erlaubt es Aufrufern (z.B. beim Schließen eines Modals), das Polling abzubrechen.
 */
export const pollLektoratUntilDone = (app, sessionId, { onProgress, intervalMs = 2000, shouldStop } = {}) => {
  return new Promise((resolve, reject) => {
    const tick = async () => {
      if (shouldStop?.()) {
        reject(new Error('cancelled'));
        return;
      }
      try {
        const data = await fetchLektoratStatus(app, sessionId);
        if (shouldStop?.()) {
          reject(new Error('cancelled'));
          return;
        }
        onProgress?.(data);
        if (data.status === 'done') {
          resolve(data);
        } else if (data.status === 'error') {
          reject(new Error(data.message || 'Lektorat fehlgeschlagen.'));
        } else {
          setTimeout(tick, intervalMs);
        }
      } catch (err) {
        reject(err);
      }
    };
    tick();
  });
};

export const fetchLektoratChanges = async (app, sessionId) => {
  const response = await api.get(`/chat/${app}/${sessionId}/lektorat/changes/`);
  return response.data.paragraphs;
};

export const resolveLektoratChanges = async (app, sessionId, decisions) => {
  const response = await api.post(`/chat/${app}/${sessionId}/lektorat/resolve/`, { decisions });
  return response.data;
};

const downloadDocxFromEndpoint = async (endpoint, filename) => {
  const response = await api.get(endpoint, { responseType: 'blob' });
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

// Lädt die vollständige Track-Changes-Version (alle Vorschläge, manuell in Word anzunehmen).
export const downloadLektoratResult = async (app, sessionId, filename = 'Lektorat_Änderungen.docx') => {
  await downloadDocxFromEndpoint(`/chat/${app}/${sessionId}/lektorat/download/`, filename);
};

// Lädt die im Review-Modal bereits final akzeptierten Änderungen (kein Track-Changes-Markup mehr).
export const downloadLektoratResolvedResult = async (app, sessionId, filename = 'Lektorat_Änderungen_final.docx') => {
  await downloadDocxFromEndpoint(`/chat/${app}/${sessionId}/lektorat/download-resolved/`, filename);
};
